export default "__VITE_ASSET__Bd58QTKW__"